import React from 'react';

// The mark of the model a take was voiced with, beside its short version
// («3.1»): the vendor's logo, so a list of takes reads at a glance. The
// Google Gemini icon is the one from Simple Icons (simpleicons.org,
// icons/googlegemini.svg, CC0 1.0), its brand colour #8E75B2 as they list it.
// The full model name sits in the tooltip. An unknown vendor shows nothing.
const GEMINI_PATH = 'M11.04 19.32Q12 21.51 12 24q0-2.49.93-4.68.96-2.19 2.58-3.81t3.81-2.55Q21.51 12 24 12q-2.49 0-4.68-.93a12.3 12.3 0 0 1-3.81-2.58 12.3 12.3 0 0 1-2.58-3.81Q12 2.49 12 0q0 2.49-.96 4.68-.93 2.19-2.55 3.81a12.3 12.3 0 0 1-3.81 2.58Q2.49 12 0 12q2.49 0 4.68.96 2.19.93 3.81 2.55t2.55 3.81';

export default function ModelMark({ model, size = 12 }) {
  const m = String(model || '');
  if (!m) return null;
  if (/gemini/i.test(m)) {
    return (
      <svg className="tk-model-mark" width={size} height={size} viewBox="0 0 24 24" role="img" aria-label={m} fill="#8E75B2" style={{ verticalAlign: '-1px', marginRight: 2 }}>
        <title>{m}</title>
        <path d={GEMINI_PATH} />
      </svg>
    );
  }
  return null;
}
